import React from 'react';
import { Inbox, AlertTriangle, MessageSquare } from 'lucide-react';
import { findStage, findPriority, isOverdue } from './crmConstants';

function InquiryListItem({ inq, today, selected, onSelect }) {
  const stage = findStage(inq.stage);
  const pri = findPriority(inq.priority);
  const overdue = isOverdue(inq, today);
  const borderCls = selected ? 'border-saffron shadow-saffron-glow' : overdue ? 'border-red-300 bg-red-50/30' : 'border-saffron-100/50';
  return (
    <button
      onClick={() => onSelect(inq.id)}
      className={`w-full text-left bg-white rounded-lg p-3.5 border transition-all hover:shadow-card-lift ${borderCls}`}
      data-testid={`inquiry-${inq.id}`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="font-sans font-semibold text-earth-dark text-sm truncate">{inq.name}</h3>
            <span className="text-[9px] px-1.5 py-0.5 rounded font-sans font-semibold" style={{ backgroundColor: stage.bg, color: stage.color }}>{stage.label}</span>
            {pri && <pri.icon size={10} style={{ color: pri.color }} />}
            {overdue && <AlertTriangle size={10} className="text-red-500" />}
          </div>
          <p className="text-xs text-earth/50 font-sans truncate mt-0.5">{inq.company} &middot; {inq.country}</p>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-[10px] uppercase tracking-wider text-saffron font-sans bg-saffron/5 px-2 py-0.5 rounded">{inq.product_interest}</span>
            {inq.notes?.length > 0 && <span className="text-[9px] text-earth/30 font-sans flex items-center gap-0.5"><MessageSquare size={8} />{inq.notes.length}</span>}
          </div>
        </div>
        <p className="text-[10px] text-earth/30 font-sans whitespace-nowrap">
          {inq.created_at ? new Date(inq.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }) : ''}
        </p>
      </div>
    </button>
  );
}

export default function InquiryList({ inquiries, today, selectedId, stageFilter, onSelect }) {
  return (
    <div className={`${selectedId ? 'lg:col-span-1' : 'lg:col-span-3'} space-y-2 max-h-[600px] overflow-y-auto`} data-testid="inquiry-list">
      {inquiries.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-lg border border-saffron-100/50" data-testid="inquiry-list-empty">
          <Inbox size={40} className="text-earth/20 mx-auto mb-3" />
          <p className="text-earth/40 font-sans text-sm">No inquiries {stageFilter !== 'all' ? `in "${stageFilter}" stage` : ''}</p>
        </div>
      ) : (
        inquiries.map(inq => (
          <InquiryListItem key={inq.id} inq={inq} today={today} selected={selectedId === inq.id} onSelect={onSelect} />
        ))
      )}
    </div>
  );
}
